<template>
    <ValidationObserver tag="form" ref="observer" @submit.prevent="submit()">
        <b-row>
            <b-col cols="12" lg="8">
                <b-card>
                    <b-row>
                        <b-col cols="12" lg="9" class="mb-3 mb-md-0">
                            <label for="nombre">Nombre de la plantilla</label>
                            <input 
                                v-model="plantilla.name"
                                placeholder="Nombre de la plantilla"
                                class="form-control"
                                id="nombre"
                                type="text"
                                :maxlength="512"
                                :disabled="edicion"
                                @input="formatInput"
                            />
                        </b-col>
        
                        <b-col cols="12" lg="3">
                            <label for="idioma">Selecciona el idioma</label>
                            <multiselect
                                v-model="plantilla.language"
                                id="idioma"
                                track-by="value"
                                label="label"
                                placeholder="Selecciona el idioma"
                                class="custom-multiselect"
                                :options="opcionesIdioma"
                                :multiple="false"
                                :disabled="edicion"
                            />
                        </b-col>
                    </b-row>
                </b-card>
                <b-card class="mt-5">
                    <b-row>
                        <b-col cols="12">
                            <FormInput 
                                v-model="plantilla.components.header.text"
                                label="Encabezado - Opcional"
                                name="encabezado"
                                class="w-100"
                                :maxlength="60"
                            >
                                <template #longitud>
                                    <small>{{ plantilla.components.header.text.length }}/60</small>
                                </template>
                            </FormInput>
                        </b-col>
        
                        <b-col cols="12" class="mt-3">
                            <label class="form-label" for="texto">Texto:</label>
                            <div class="textarea-wrapper">
                                <ValidationProvider name="texto" rules="required" v-slot="{ errors }">
                                    <textarea
                                        ref="texto"
                                        id="texto"
                                        v-model="plantilla.components.body.text"
                                        :maxlength="1024"
                                        class="form-control"
                                        :class="{'is-invalid': errors[0]}"
                                        rows="10"
                                    ></textarea>
                                    <span 
                                        v-if="errors[0]" 
                                        class="d-block invalid-feedback text-xs bg-danger white h7 p-2 font-weight-bold" 
                                    >
                                        {{ errors[0] }}
                                    </span>
                                </ValidationProvider>
                                <div class="char-counter">
                                    {{ plantilla.components.body.text.length }}/1024
                                </div>
                                <div class="format-toolbar">
                                    <emoji-picker @emoji="insert">
                                        <div slot="emoji-invoker" slot-scope="{ events: { click: clickEvent } }" @click.stop="clickEvent">
                                            <button type="button" class="btn btn-format">😊</button>
                                        </div>
                                        <div slot="emoji-picker" slot-scope="{ emojis, insert }">
                                            <div class="emoji-popover">
                                                <div v-for="(emojiGroup, category) in emojis" :key="category">
                                                    <div class="emoji-group">
                                                        <span
                                                            v-for="(emoji, emojiName) in emojiGroup"
                                                            :key="emojiName"
                                                            :title="emojiName"
                                                            class="emoji-item"
                                                            @click="insert(emoji)"
                                                        >
                                                            {{ emoji }}
                                                        </span>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </emoji-picker>
                                    <b-button type="button" v-b-popover.hover.top="'Negrita (Ctrl + b)'" class="btn-format" @click="insertFormat('*')">
                                        <strong style="color: #5a5f66;">B</strong>
                                    </b-button>
                                    <b-button type="button" v-b-popover.hover.top="'Cursiva (Ctrl + i)'" class="btn-format" @click="insertFormat('_')">
                                        <em style="color: #5a5f66;">I</em>
                                    </b-button>
                                    <b-button type="button" v-b-popover.hover.top="'Tachado'" class="btn-format" @click="insertFormat('~')">
                                        <s style="color: #5a5f66;">S</s>
                                    </b-button>
                                    <b-button type="button" v-b-popover.hover.top="'Monoespaciado'" class="btn-format" @click="insertFormat('```')">
                                        <code style="color: #5a5f66;">&lt;/&gt;</code>
                                    </b-button>
                                </div>
                            </div>
                        </b-col>
                        <b-col cols="12" class="mt-4">
                            <FormInput 
                                v-model="plantilla.components.footer.text"
                                label="Pié de página - Opcional"
                                name="pie-pagina"
                                class="w-100"
                                :maxlength="60"
                            >
                                <template #longitud>
                                    <small>{{ plantilla.components.footer.text.length }}/60</small>
                                </template>
                            </FormInput>
                        </b-col>
                    </b-row>
                </b-card>
        
                <b-card class="mt-5 mb-4 mb-md-5">
                    <h5 class="mb-4">BOTONES - OPCIONAL</h5>
                    <b-row class="align-items-center">
                        <b-col cols="12" lg="5">
                            <FormInput 
                                :key="'boton-' + reloadButtons"
                                v-model="newButton.text"
                                label="Texto del botón"
                                name="button-text"
                                class="w-100"
                                :maxlength="25"
                            />
                        </b-col>
        
                        <b-col cols="12" lg="5">
                            <FormInput 
                                :key="'url-' + reloadButtons"
                                v-model="newButton.url"
                                label="URL del botón"
                                name="button-url"
                                class="w-100"
                                :maxlength="2000"
                                rules="url"
                            />
                        </b-col>
        
                        <b-col cols="12" lg="2" class="d-flex align-items-end">
                            <b-button 
                                variant="primary"
                                class="w-100"
                                type="button"
                                :disabled="loading || (!newButton.text || !newButton.url)"
                                @click="addButton()"
                            >
                                Agregar
                            </b-button>
                        </b-col>
                        <b-col cols="10" class="alert alert-danger ml-3" v-if="errorButton">
                            {{ errorButton }}
                        </b-col>
                    </b-row>
        
                    <b-list-group class="mt-3" style="overflow-y: auto; max-height: 500px;" v-if="plantilla.components.buttons.length">
                        <b-list-group-item 
                            v-for="(button, index) in plantilla.components.buttons" 
                            :key="index" 
                            class="d-flex justify-content-between align-items-center"
                        >
                            <div>
                                <strong>{{ button.text }}</strong> - 
                                <small class="text-muted">{{ button.url }}</small>
                            </div>
                            <b-button variant="danger" size="sm" @click="removeButton(index)" :disabled="loading">
                                ✖
                            </b-button>
                        </b-list-group-item>
                    </b-list-group>
                </b-card>
            </b-col>
            <b-col cols="12" lg="4" class="sticky-preview" v-if="hayContenido">
                <div class="title">
                    Vista previa de la plantilla
                </div>
                <VistaPreviaComponent :components="plantilla.components" />
            </b-col>
        </b-row>
        <b-col cols="12" v-if="errors && Object.keys(errors).length" class="p-0">
            <b-alert variant="danger" show>
                <ul class="mb-0 pl-2">
                    <li v-for="(mensajes, campo) in errors" :key="campo">
                        <span v-for="(mensaje, index) in mensajes" :key="index">
                            {{ mensaje }}
                        </span>
                    </li>
                </ul>
            </b-alert>
        </b-col>
        <b-col cols="12" lg="8" class="mt-3 mt-md-0 pr-0 pr-md-2 pl-0 text-right">
            <b-button class="button large-button" :class="esMovil ? 'btn-block' : ''" type="submit" :disabled="loading">Guardar</b-button>
        </b-col>
    </ValidationObserver>
</template>

<script>
import EmojiPicker from 'vue-emoji-picker';
import VistaPreviaComponent from './VistaPreviaComponent';

export default {
    props: {
        plantilla: {
            type: Object,
            required: true
        },
        loading: {
            type: Boolean,
            required: true
        },
        errors: {
            type: Array,
            required: true
        }
    },
    data() {
        return {
            newButton: {
                text: "",
                url: ""
            },
            opcionesIdioma: [
                { value: 'es_ES', label: 'Español (ES)' },
                { value: 'en_US', label: 'Inglés (US)' },
                { value: 'en', label: 'Inglés (Genérico)' },
                { value: 'ca', label: 'Catalán (CA)' }
            ],
            errorButton: "",
            reloadButtons: 1
        }
    },
    methods: {
        async submit() {
            const isValid = await this.$refs.observer.validate();
            if (isValid) {
                this.$emit('terminado');
            }
        },
        addButton() {
            if (this.plantilla.components?.buttons?.length === 2) {
                this.errorButton = "No se pueden añadir más de 2 botones por plantilla.";
                return;
            }

            if (this.newButton.text?.length > 25 || this.newButton.url?.length > 2000) {
                this.errorButton = "Texto o URL exceden el límite permitido.";
                return;
            }

            this.plantilla.components.buttons.push({ ...this.newButton });

            this.newButton = { text: '', url: '' };
            this.errorButton = "";
            this.reloadButtons++;
        },
        removeButton(index) {
            this.plantilla.components.buttons.splice(index, 1);
        },
        handleShortcut(event) {
            if (event.ctrlKey || event.metaKey) {
                if (event.key.toLowerCase() === "b") {
                    event.preventDefault();
                    this.insertFormat("*");
                } else if (event.key.toLowerCase() === "i") {
                    event.preventDefault();
                    this.insertFormat("_");
                }
            }
        },
        insertFormat(symbol) {
            const textarea = this.$refs.texto;
            if (!textarea) return;
            const start = textarea.selectionStart;
            const end = textarea.selectionEnd;
            const original = textarea.value;
            const before = original.substring(0, start);
            const after = original.substring(end);
            const newText = before + symbol + symbol + after;
            this.plantilla.components.body.text = newText;
            this.$nextTick(() => {
                textarea.focus();
                const pos = start + symbol.length;
                textarea.setSelectionRange(pos, pos);
            });
        },
        insert(emoji) {
            this.plantilla.components.body.text += emoji;
        },
        formatInput() {
            this.plantilla.name = this.plantilla.name.toLowerCase().replace(/ /g, '_');
        }
    },
    computed: {
        hayEncabezado() {
            return this.plantilla.components?.header?.text?.trim();
        },
        hayTexto() {
            return this.plantilla.components?.body?.text?.trim();
        },
        hayPiePagina() {
            return this.plantilla.components?.footer?.text?.trim();
        },
        hayBotones() {
            return this.plantilla.components?.buttons?.length > 0;
        },
        hayContenido() {
            return this.hayEncabezado || this.hayTexto || this.hayPiePagina || this.hayBotones;
        },
        esMovil() {
            return window.innerWidth <= 768;
        },
        edicion() {
            return window.location.href.includes('editar');
        }
    },
    mounted() {
        window.addEventListener("keydown", this.handleShortcut);

        if(typeof this.plantilla.language !== 'object') {
            const idioma = this.opcionesIdioma.find(idioma => idioma.value === this.plantilla.language);

            if (idioma) {
                this.plantilla.language = idioma;
            }
        }
    },
    beforeDestroy() {
        window.removeEventListener("keydown", this.handleShortcut);
    },
    components: {
        EmojiPicker, VistaPreviaComponent
    }
}
</script>

<style scoped>
.preview-card {
    background: #f8f9fa;
    border-radius: 8px;
    text-align: center;
}

.preview-body {
    font-size: 1.1em;
    text-align: center;
}

.textarea-wrapper {
    position: relative;
}

.char-counter {
    position: absolute;
    top: 5px;
    right: 10px;
    background: rgba(255, 255, 255, 0.7);
    color: #AAAAAA;
    padding: 2px 5px;
    font-size: 0.8em;
    border-radius: 3px;
}

.format-toolbar {
    display: flex;
    align-items: center;
    gap: 5px;
    justify-content: flex-end;
}

.btn-format {
    font-size: 1.2em;
    margin-left: 5px;
    background-color: transparent;
    color: black !important;
    padding: 5px;
}

.btn-format:hover {
    background-color: transparent;
}

.emoji-popover {
    position: absolute;
    right: 50px;
    z-index: 1000;
    background-color: #fff;
    border: 1px solid #ddd;
    border-radius: 6px;
    box-shadow: 0 2px 8px rgba(0,0,0,0.15);
    padding: 10px;
    margin-top: 5px;
    max-height: 300px;
    width: 300px;
    overflow-y: auto;
}

@media (max-width: 768px) {
    .emoji-popover {
        width: 200px !important;
    }

    .title {
        width: 305px !important;
    }
}

.emoji-group {
    padding-left: 0;
    margin-bottom: 10px;
}

.emoji-item {
    cursor: pointer;
    font-size: 1.4em;
    padding: 5px;
    transition: background-color 0.2s;
    border-radius: 4px;
}

.emoji-item:hover {
    background-color: #f0f0f0;
}

.emoji-popover::-webkit-scrollbar {
  width: 20px;
}

.emoji-popover::-webkit-scrollbar-track {
  background-color: transparent;
}

.emoji-popover::-webkit-scrollbar-thumb {
  background-color: #d6dee1;
  border-radius: 20px;
  border: 6px solid transparent;
  background-clip: content-box;
}

.emoji-popover::-webkit-scrollbar-thumb:hover {
  background-color: #a8bbbf;
}

.title {
    font-size: 20px;
    padding: 20px;
    width: 450px;
    background-color: #F8F8F8;
}

.sticky-preview {
    position: sticky;
    top: 20px;
    height: fit-content;
}
</style>